import React, { useState } from 'react';
import { TextField, Button, Container, Typography, Box, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import img from '../assets/banner.jpg';
import logo from '../assets/LWPL_White_Logo.png';
import { login } from '../api';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await login({ email, password });
      console.log('Login Response at 06:11 PM IST:', res);
      if (res.token) {
        localStorage.setItem('token', res.token);
        localStorage.setItem('email', email);
        navigate('/dashboard');
      } else {
        setError(res.error || 'Login failed');
      }
    } catch (err) {
      console.error('Login error at 06:11 PM IST:', err);
      setError(`Login error: ${err.error || err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleRegisterRedirect = (e) => {
    e.preventDefault(); // Prevent any default behavior
    navigate('/register');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Container maxWidth="sm" style={{ marginTop: '10%' }}>
        <Box display="flex" justifyContent="center" mb={8}>
          <img src={logo} alt="Logo" style={{ height: 150 }} />
        </Box>
        <Typography variant="h4" gutterBottom align="center">Login</Typography>
        <form onSubmit={handleLogin}>
 <TextField
        label="Email"
        fullWidth
        margin="normal"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        disabled={loading}
        sx={{
          '& input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px #121212 inset', // Matches portal's dark background
            WebkitTextFillColor: '#fff', // Ensures text remains white
            backgroundColor: '#121212', // Dark background for autofill
          },
          '& input:-webkit-autofill:focus': {
            WebkitBoxShadow: '0 0 0 1000px #121212 inset, 0 0 0 2px #e0b256', // Highlight with theme color on focus
            WebkitTextFillColor: '#fff',
          },
          '& .MuiInputBase-root': {
            backgroundColor: '#1e1e1e', // Consistent with form input background
            color: '#fff',
          },
          '& .MuiInputLabel-root': {
            color: '#ccc', // Label color to match sidebar
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: '#e0b256', // Theme color on focus
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#ccc',
            },
            '&:hover fieldset': {
              borderColor: '#e0b256', // Theme color on hover
            },
            '&.Mui-focused fieldset': {
              borderColor: '#e0b256', // Theme color on focus
            },
          },
        }}
      />
      <TextField
        label="Password"
        type="password"
        fullWidth
        margin="normal"
        required
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        disabled={loading}
        sx={{
          '& input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px #121212 inset', // Matches portal's dark background
            WebkitTextFillColor: '#fff', // Ensures text remains white
            backgroundColor: '#121212', // Dark background for autofill
          },
          '& input:-webkit-autofill:focus': {
            WebkitBoxShadow: '0 0 0 1000px #121212 inset, 0 0 0 2px #e0b256', // Highlight with theme color on focus
            WebkitTextFillColor: '#fff',
          },
          '& .MuiInputBase-root': {
            backgroundColor: '#1e1e1e', // Consistent with form input background
            color: '#fff',
          },
          '& .MuiInputLabel-root': {
            color: '#ccc', // Label color to match sidebar
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: '#e0b256', // Theme color on focus
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#ccc',
            },
            '&:hover fieldset': {
              borderColor: '#e0b256', // Theme color on hover
            },
            '&.Mui-focused fieldset': {
              borderColor: '#e0b256', // Theme color on focus
            },
          },
        }}
      />
          <Button
  variant="contained"
  sx={{
    mt: 2,
    backgroundColor: '#e0b256',
    '&:hover': {
      backgroundColor: '#c7993d', // Slightly darker shade for hover effect
    },
    '&:disabled': {
      backgroundColor: '#e0b25666', // Semi-transparent for disabled state
    },
  }}
  type="submit"
  fullWidth
  disabled={loading}
>
  

            {loading ? <CircularProgress size={24} /> : 'Login'}
          </Button>
          {error && (
            <Typography color="error" align="center" sx={{ mt: 2 }}>
              {error}
            </Typography>
          )}
        </form>
                  {/* <Typography align="center" sx={{ mt: 2 }}>
                    Don't have an account?{' '}
                    <Typography
                      component="span"
                      color="primary"
                      sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                      onClick={handleRegisterRedirect}
                    >
                      Register here
                    </Typography>
                  </Typography> */}
      </Container>
    </Box>
  );
}

export default Login;